import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Download } from 'lucide-react';

import { Message, AsyncButton } from '@getro/rombo';

import { post } from 'api';
import { trackException } from 'helpers/errorTracker';
import { trackEvent } from 'helpers/analytics';
import { Box, Flex, Text } from 'rebass/styled-components';
import { GenericError } from '../../../components/molecules/genericError';

const RequestData = () => {
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const cancelTokenSource = useRef(axios.CancelToken.source());

  const handleSubmit = async () => {
    setSubmitting(true);
    setSuccess(false);
    setError(false);
    try {
      await post('/messages/user-data', {}, { cancelToken: cancelTokenSource.current.token });
      setSubmitting(false);
      setSuccess(true);

      trackEvent('requested_personal_data');
    } catch (e) {
      trackException(e);
      setSubmitting(false);
      setError(true);
    }
  };

  useEffect(
    () => () => {
      cancelTokenSource.current.cancel();
    },
    [],
  );

  return (
    <Flex sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
      <Text fontSize="14px" fontWeight="medium" color="text.dark">
        Your data
      </Text>
      <Text fontSize="14px">Download a file with the most relevant information. We’ll email you when it’s ready.</Text>
      {!success && (
        <AsyncButton size="small" width="fit-content" variant="secondary" loading={submitting} onClick={handleSubmit}>
          <Flex sx={{ columnGap: '10px' }} alignItems="center">
            <Box as={Download} height="16px" width="16px" aria-hidden="true" />
            Download my data file
          </Flex>
        </AsyncButton>
      )}
      {success && (
        <Box
          as={Message}
          mt={3}
          type="success"
          content="We are processing your request, we will send all your data to your email."
        />
      )}
      {error && <Box as={GenericError} mt={3} />}
    </Flex>
  );
};

export default RequestData;
